import styled from 'styled-components'
import {
    PersonOutline as PersonOutlineIcon,
    CalendarTodayOutlined as CalendarTodayOutlinedIcon,
    HourglassEmptyOutlined as HourglassEmptyOutlinedIcon,
    LocationOnOutlined as LocationOnOutlinedIcon
} from '@material-ui/icons';

import ProImage from "components/Icons/ProImage";
import EliteImage from "components/Icons/EliteImage";

export const Container = styled.div`
  height: calc(100% - 158px);
  overflow-y: auto;
  margin-bottom: 4rem;
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
  width: 100%;

  @media(min-width: 768px) {
    margin-top: 1rem;
  }
`

export const JobContainer = styled.div<{ $isActive?: boolean }>`
  margin: 1rem 0;
  background-color: ${({ $isActive }) => $isActive ? 'var(--background-success, #F1F7FF)':'var(--background-info, #F7F7F7)'}; 
  padding: 1.25rem;
  border-radius: 16px;

  &:first-child {
    margin-top: 0;
  }
  
  &:last-child {
    margin-bottom: 5rem;
  }
  
  @media(min-width: 768px) {
    padding: 1.5rem;
  }
`

export const TitlesContainer = styled.div` 
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 1rem;
`

export const Title = styled.div`
  font-size: var(--typography-h6-size, 1.25rem);
  font-weight: 600;
  color: rgba(0, 0, 0, 0.87);
  margin-bottom: 0.25rem;
  
  @media(min-width: 768px) {
    font-size: 1.375rem;
  }
`

export const Subtitle = styled.div`
  display: flex;
  align-items: center;
  font-size: var(--typography-body-1-bold-size, 1rem);
  line-height: 1.4;
`

export const NewCandidatesInfo = styled.div`
  display: flex;
  align-items: center;
  padding: 0.25rem 0.5rem;
  color: #fff;
  font-weight: 500;
  font-size: var(--typography-body2-size, 0.875rem);
  border-radius: 0.5rem;
  background-color: #13CA82;
  min-width: auto;

  @media (max-width: 465px) {
    margin-left: 0.5rem;
    font-size: 0.65rem;
  }
`

export const CandidateInfo = styled.div`
  font-weight: bold;
  color: var(--info-main, #0288D1);
  font-size: var(--typography-body-1-bold-size, 1rem);
`

export const PendingJobInfo = styled.div`
  display: flex;
  align-items: center;
  padding: 0.25rem 0.5rem;
  color: #fff;
  font-weight: 500;
  font-size: 0.75rem;
  border-radius: 0.5rem;
  background-color: #988C81FF;
  margin-left: 1rem;
  min-width: auto;

  @media (max-width: 465px) {
    margin-left: 0.5rem;
    font-size: 0.65rem;
  }
`

export const PersonOutlineIconStyled = styled(PersonOutlineIcon)`
  margin-right: 0.25rem;
  height: 18px;
`

export const PersonOutlineIconInColorStyled = styled(PersonOutlineIconStyled)`
  color: #0B4598;
  text-align: start;
`

export const HourglassEmptyOutlinedIconStyled = styled(HourglassEmptyOutlinedIcon)`
  color: #fff;
  height: 18px;
`

export const CalendarTodayOutlinedIconStyled = styled(CalendarTodayOutlinedIcon)`
  font-size: var(--typography-body-1-bold-size, 1rem);
  margin 0 0.25rem;
  color: #0B4598;
`

export const LocationOnOutlinedIconStyled = styled(LocationOnOutlinedIcon)`
  font-size: var(--typography-body-1-bold-size, 1rem);
  margin 0 0.25rem;
  color: #0B4598;
`

export const StartingDate = styled.span<{ $isHygienist?: boolean }>`
  font-size: var(--typography-body-1-bold-size, 1rem);
  margin-left: ${({ $isHygienist }) => $isHygienist ? '0.3rem' : '0'};
`

export const JobInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
 
`

export const JobInfoItem = styled.div`
  display: flex;
  align-items: center;
  color: var(--info-main, #0288D1)
  font-size: 0.75rem;
  
  @media (max-width: 465px) {
    width: 100%;
    
    &:first-child {
      margin-bottom: 0.25rem;
    }
  }
`

export const Badge = styled.div`
  margin-left: 0.25rem;
`;

export const StyledProImage = styled(ProImage)`
  height: 18px !important;;
`

export const StyledEliteImage = styled(EliteImage)`
  height: 18px !important;;
`
